import { useEffect, RefObject } from 'react';

/**
 * @description Hook that listens to clicks outside of the passed ref and invokes a
 * callback function
 */
const useOutsideClickHandler = (
  ref: RefObject<any>,
  cb: (event: MouseEvent) => void
): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target)) {
        cb(event);
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, cb]);
};

export default useOutsideClickHandler;
